<template>
	<div class="shop" v-infinite-scroll="loadMore" infinite-scroll-immediate="false">
		<!-- <span>{{hasProduct}}</span> -->
		<ul v-if="hasProduct" class="shopList">
			<li @click="toLink" v-for="(item,index) in shopList" :key="index" class="clearfix">
				<div class="shopPic"><img :src="shopPic" alt=""></div>
				<div class="shopMes">
					<div class="shopTit">{{item.name}}</div>
					<div class="shopName">
						<span>{{item.address}}</span>
						<div v-if="item.kilometers" class="distance">{{item.kilometers}}km</div>
					</div>
		
					<!-- <div class="price"><span>￥</span>{{item.salePrice}}</div> -->
					<div class="buyBtn">立即购买</div>
				</div>
			</li>
		</ul>
		
		<div v-else class="noProduct">
			暂无商家
		</div>
		
		<FootTab></FootTab>
	</div>
	
	
	
</template>

<script>
	import Vue from 'vue';
	import FootTab from "@/components/FootTab.vue";
	
	export default {
		name: "home",
		components: {
			FootTab
		},
		props: ['typeName'],
		data() {
			return {
				"shopList":[],
				"pageNum":0,
				"loading":true,
				"hasProduct":true,
				"bizId":"",
				"shopPic":"",
				
				"lat":"",
				"lon":""
			}
		},
		activated() {

		},
		created() {
			this.bizId = this.$route.query.bizId;
			this.type = this.$route.query.type;
			this.productType = this.$route.query.productType;
			this.shopPic = sessionStorage.getItem("shopPic")
		},
		mounted() {
			// this.getProduct();
			
			if (this.productType == 1) {
				if (sessionStorage.getItem("locationType") == "1") {
					this.lat = eval('(' + sessionStorage.getItem("LocationMes") + ')').position.lat;
					this.lon = eval('(' + sessionStorage.getItem("LocationMes") + ')').position.lng;
				} else if(sessionStorage.getItem("locationType") == "2"){
					
					this.lat = eval('(' + sessionStorage.getItem("LocationMes") + ')').rectangle.split(";")[1].split(",")[1];
					this.lon = eval('(' + sessionStorage.getItem("LocationMes") + ')').rectangle.split(";")[1].split(",")[0];
				}else{
					console.log("未获取到定位信息");
				}
			}
			
			
			
		},
		methods: {
			defImg() { // 图片加载失败时加载占位图
				let img = event.srcElement;
				img.src = this.defaultImg;
				img.onerror = null; //防止闪图
			},
			getProduct() { //获取活动
				var that = this;
				that.http.getShopByProduct({
					"bizId":this.bizId,
					"type":this.type,
					"lat":"30.29216",
					"lon":"120.07518"
				}).then((res) => {
					console.log(res.data);
					if (res.data.data.length == 0 && that.pageNum<2) {
						that.hasProduct = false;
					}
					
					if (res.data.data.length < 10) {
						that.loading = false;
						that.shopList.push(...res.data.data);
					} else{
						that.shopList.push(...res.data.data);
					}
				})
			},
			toLink(){
				window.location.href = sessionStorage.getItem("shopLink")
			},
			loadMore(){
				var that = this;
				if (that.loading == false) {
					return;
				}
				that.pageNum = that.pageNum + 1;
				
				that.getProduct();
			},
			
		}

	};
</script>

<style scoped lang="scss">
	.shop::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	.shop {
		height: 100vh;
		overflow: auto;
		padding: 0.3rem 0.2rem 1.6rem 0.3rem;
		scrollbar-width: none; /* firefox */
		-ms-overflow-style: none; /* IE 10+ */
		
		
		.shopList {
			text-align: left;
		
			li {
				padding: 0.32rem 0px;
				border-bottom: 1px solid #ebebeb;
		
				.shopPic {
					float: left;
					width: 2.23rem;
					height: 2.23rem;
					// background-color: #afafaf;
					border-radius: 0.16rem;
					line-height: 2.23rem;
					
					img{
						display: inline-block;
						vertical-align: middle;
						width: 100%;
					}
				}
		
				.shopMes {
					float: right;
					width: 4.5rem;
					height: 2.23rem;
					position: relative;
		
					.shopTit {
						font-size: 0.28rem;
						color: #1c1c1c;
						line-height: 0.38rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box; // 作为弹性伸缩盒子模型显示。
						-webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
						-webkit-line-clamp: 2; // 显示的行
						text-align: justify;
					}
		
					.shopName {
						color: rgba(28, 28, 28, 0.6);
						font-size: 0.24rem;
						margin-top: 0.14rem;
						position: relative;
						display: -webkit-box; // 作为弹性伸缩盒子模型显示。
						-webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
						-webkit-line-clamp: 4; // 显示的行
						text-align: justify;
						line-height: 0.32rem;
						padding-right: 1.3rem;
						overflow: hidden;
								
						.distance {
							position: absolute;
							right: 0;
							top: 0;
							height: 0.2rem;
							color: rgba(28, 28, 28, 0.6);
						}
					}
		
					.price {
						position: absolute;
						font-size: 0.34rem;
						color: #f73030;
						font-weight: bold;
						left: 0;
						bottom: 0;
		
						span {
							font-size: 0.24rem;
						}
					}
		
					.buyBtn {
						position: absolute;
						bottom: 0;
						right: 0;
						width: 1.44rem;
						height: 0.5rem;
						line-height: 0.5rem;
						background-image: linear-gradient(270deg,
							#ff5b23 0%,
							#fb8d17 100%),
							linear-gradient(#e2373d,
							#e2373d);
						border-radius: 100px;
						text-align: center;
						color: #fff;
						font-size: 0.24rem;
					}
				}
		
			}
		
		
		
		}
		
		.noProduct{
			text-align: center;
			font-size: 0.36rem;
			color: #999999;
			font-weight: bold;
			padding-top: 2rem;
			letter-spacing: 0.06rem;
		}
	}
</style>
